import React from 'react';
import { Link } from 'react-router-dom';
import { Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/navigation'
import 'swiper/css/pagination'


const swiperOptions = {
  modules: [Pagination, Navigation],
  slidesPerView: 1,
  loop: true,
  effect: 'fade',
  pagination: {
    el: '#main-slider-pagination',
    type: 'bullets',
    clickable: true
  },
  navigation: {
    nextEl: '#main-slider__swiper-button-next',
    prevEl: '#main-slider__swiper-button-prev'
  }
}

export default function Banner() {
  return (
    <>
    {/* banner-one */}
    <section id='th-home' className="main-slider">
            <Swiper {...swiperOptions} className="swiper-container thm-swiper__slider">
            <div className="swiper-wrapper">
              <SwiperSlide className="swiper-slide">
                <div className="main-slider__video-bg">
                  <video 
                    autoPlay 
                    muted 
                    playsInline
                    className="main-slider__video"
                  >
                    <source src="/new2.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="main-slider__content">
                        <p className="main-slider__sub-title">Promotional Products That Make an Impact</p>
                        <h2 className="main-slider__title">
                          Let Us - Help You <br /> <span>Build Your Brand</span>
                        </h2>
                        <p className="main-slider__text">
                          From custom apparel to corporate gifts, we deliver quality promotional merchandise <br /> that gets your message noticed. Trusted by businesses, schools, and organizations nationwide.
                        </p>
                        <ul className="list-unstyled main-slider__address">
                          <li>
                            <div className="icon">
                              <span className="icon-pin"></span>
                            </div>
                            <div className="text">
                              <p>Over 10,000 Products Available</p>
                            </div>
                          </li>
                          <li>
                            <div className="icon">
                              <span className="icon-clock"></span>
                            </div>
                            <div className="text">
                              <p>No Minimum Orders on Select Items</p>
                            </div>
                          </li>
                        </ul>
                        <div className="main-slider__btn-box">
                          <Link to="/contact" className="main-slider__btn thm-btn">
                            Get a Free Quote
                            <span className="icon-arrow-right"></span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide className="swiper-slide">
              <div className="main-slider__video-bg">
                  <video 
                    autoPlay 
                    muted 
                    playsInline
                    className="main-slider__video"
                  >
                    <source src="/new2.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="main-slider__content">
                        <p className="main-slider__sub-title">Quality Products, Competitive Pricing</p>
                        <h2 className="main-slider__title">
                          Your One-Stop Shop for <br /> <span>Branded Merchandise</span>
                        </h2>
                        <p className="main-slider__text">
                          Whether you need 10 items or 10,000, we provide personalized service and expert guidance <br /> to bring your vision to life. Fast turnaround times guaranteed.
                        </p>
                        <ul className="list-unstyled main-slider__address">
                          <li>
                            <div className="icon">
                              <span className="icon-pin"></span>
                            </div>
                            <div className="text">
                              <p>Rush Orders Available</p>
                            </div>
                          </li>
                          <li>
                            <div className="icon">
                              <span className="icon-clock"></span>
                            </div>
                            <div className="text">
                              <p>Free Design Assistance</p>
                            </div>
                          </li>
                        </ul>
                        <div className="main-slider__btn-box">
                          <Link to="/contact" className="main-slider__btn thm-btn">
                            Request Quote
                            <span className="icon-arrow-right"></span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide className="swiper-slide">
              <div className="main-slider__video-bg">
                  <video 
                    autoPlay 
                    muted 
                    playsInline
                    className="main-slider__video"
                  >
                    <source src="/new2.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="main-slider__content">
                        <p className="main-slider__sub-title">On Time • On Point • On Budget</p>
                        <h2 className="main-slider__title">
                          Make Your Mark with <br /> <span>Custom Promotional Items</span>
                        </h2>
                        <p className="main-slider__text">
                          From trade shows to team events, we help you create lasting impressions <br /> with high-quality branded merchandise that fits your budget and timeline.
                        </p>
                        <ul className="list-unstyled main-slider__address">
                          <li>
                            <div className="icon">
                              <span className="icon-pin" />
                            </div>
                            <div className="text">
                              <p>Nationwide Shipping</p>
                            </div>
                          </li>
                          <li>
                            <div className="icon">
                              <span className="icon-clock" />
                            </div>
                            <div className="text">
                              <p>Satisfaction Guaranteed</p>
                            </div>
                          </li>
                        </ul>
                        <div className="main-slider__btn-box">
                          <Link to="/contact" className="main-slider__btn thm-btn">
                            Start Your Order <span className="icon-arrow-right" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

            </div>
          </Swiper>
          <div className="swiper-pagination" id="main-slider-pagination" />

        </section>
        {/* banner-one */}
    </>
    
  );
}